import Component from '@bythepixel/component-loader';

export default class ClipboardCopy extends Component {
  static selector = '[data-comp-clipboard-copy]'
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);
    this.copyInput = this.$container.querySelector('[data-clipboard-copy-input]');
    this.copyButton = this.$container.querySelector('[data-clipboard-copy-button]');
    this.addListeners();
  }

  addListeners() {
    this.addCopyButtonListener();
    this.addOnUnloadListener();
  }

  addCopyButtonListener() {
    this.copyInputValueToClipboard = this.copyInputValueToClipboard.bind(this);
    this.copyButton.addEventListener('click', this.copyInputValueToClipboard);
  }

  removeCopyButtonListener() {
    this.copyButton.removeEventListener('click', this.copyInputValueToClipboard);
  }

  copyInputValueToClipboard() {
    navigator.clipboard.writeText(this.copyInput.value);
    this.changeCopyButtonText();
  }

  changeCopyButtonText() {
    this.copyButton.innerHTML = 'Copied';

    setTimeout(() => {
      this.copyButton.innerHTML = 'Copy';
    }, 1750);
  }

  addOnUnloadListener() {
    window.onunload = () => {
      this.removeCopyButtonListener();
    }
  }
}
